export const langType = [
  {
    value: 1,
    label: '中文',
  },
  {
    value: 2,
    label: '英文',
  },
  {
    value: 3,
    label: '中&英',
  },
]

export const blogType = [
  {
    value: 1,
    label: '创意洞察',
  },
  {
    value: 2,
    label: '创意课堂',
  },
  {
    value: 3,
    label: '创意案例',
  },
]

export const blogLangType = [
  {
    value: 1,
    label: '中文',
  },
  {
    value: 2,
    label: '英文',
  },
  {
    value: 3,
    label: '日文',
  },
  {
    value: 4,
    label: '韩文',
  },
]

export const caseTag = [
  {
    value: 1,
    label: '休闲游戏',
  },
  {
    value: 2,
    label: '中重度游戏',
  },
  {
    value: 3,
    label: '工具类应用',
  },
  {
    value: 4,
    label: '品牌',
  },
  {
    value: 5,
    label: '视频',
  },
  {
    value: 6,
    label: '2D 可玩',
  },
  {
    value: 7,
    label: '3D 可玩',
  },
  {
    value: 8,
    label: '互动视频',
  },
  {
    value: 9,
    label: 'Mindworks 创意定制',
  },
  {
    value: 10,
    label: 'Playturbo 托管',
  },
  {
    value: 11,
    label: '使用 Playturbo 制作',
  },
]

export const categoryType = [
  {
    value: 1,
    label: '创意洞察',
  },
  {
    value: 2,
    label: '创意课堂',
  },
  {
    value: 3,
    label: '创意案例',
  },
]

export const casesType = [
  {
    value: 1,
    label: '行业类型',
  },
  {
    value: 2,
    label: '创意类型',
  },
  {
    value: 3,
    label: '解决方案',
  },
]

export const orientationConfig = [
  {
    value: 1,
    label: '横屏',
  },
  {
    value: 2,
    label: '竖屏',
  },
]

export const logoPosition = [
  {
    value: 11,
    label: '白色-左下',
  },
  {
    value: 21,
    label: '灰色-左下',
  },
  {
    value: 12,
    label: '白色-右下',
  },
  {
    value: 22,
    label: '灰色-右下',
  },
]

export const uploadType = [
  {
    value: 1,
    label: '基础包上传',
  },
  {
    value: 2,
    label: '手动上传',
  },
]
